// extracted by mini-css-extract-plugin
export var borderRadius = "_ed-4";
export var large = "_ed-3";
export var logoContainer = "_ed-0";
export var nameLogo = "_ed-2";
export var small = "_ed-1";